import React, { useState } from 'react';
import './SpellBee.css';

const words = ['cat', 'dog', 'elephant', 'giraffe', 'hippopotamus', 'kangaroo', 'lion', 'monkey', 'penguin', 'zebra', "apple", "banana", "cat", "dog", "elephant", "fish", "goat", "hat", "ice", "jacket","go","come","wait","have","has","want","give","say",
  "bat","ball","car","donkey","kite","good","bad","sit", "stand","walk","run","man","woman","child","infant","kid","shirt","pant","dress","learn",
  "other","another","look","Carrot","Broccolli","Beetroot","Eggplant","Tomato","Bell pepper","Cauliflower","cabbage","Spinach","Pumpkin","Radish", 
  "Garlic","Ginger","Onion","lettuce","beans","Red","Blue","Brown","Black","Green","white","Yellow","Orange","Purple","Gray","Peach","cyan","January","February","March","April","May","June","July","August","September","October","November","December",
"Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];

const SpellBee = () => {
  const [currentWord, setCurrentWord] = useState('');
  const [userSpelling, setUserSpelling] = useState('');
  const [score, setScore] = useState(0);

  const getNewWord = () => {
    const randomIndex = Math.floor(Math.random() * words.length);
    setCurrentWord(words[randomIndex]);
    setUserSpelling('');
  };

  const handleInputChange = (e) => {
    setUserSpelling(e.target.value);
  };

  const verifySpelling = () => {
    if (userSpelling.toLowerCase() === currentWord.toLowerCase()) {
      setScore(score + 1);
      alert('Correct!');
    } else {
      alert('Incorrect!');
    }
  };

  return (
    <div className="AppSB">
      <h1>Spell Bee Game</h1>
      <div className="word-section">
        <button onClick={getNewWord}>Next Spell</button>
        {currentWord && (
          <div>
            <p>Spell the word: {currentWord}</p>
            <input type="text" value={userSpelling} onChange={handleInputChange} />
            <button onClick={verifySpelling}>Right or Wrong</button>
          </div>
        )}
      </div>
      <div className="score-section">
        <h2>Score: {score}</h2>
      </div>
    </div>
  );
};

export default SpellBee;

